import React, { useState } from "react";
import styled from "styled-components";
import logo1 from "../assets/logo1.png";
import { Link } from "react-router-dom";
import { IoMdArrowDropdown } from "react-icons/io";
import { BiLinkExternal } from "react-icons/bi";
import { FaRegUser } from "react-icons/fa";
import { VscBook } from "react-icons/vsc";
import { BiSupport } from "react-icons/bi";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { RiMenu3Fill } from "react-icons/ri";
import DashboardMobilenav from "./DashboardMobilenav";

const DashHeader = () => {
  const [showHelp, setShowHelp] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [mobileNav, setMobileNav] = useState(false);
  return (
    <>
      {mobileNav === true ? (
        <DashboardMobilenav setMobileNav={setMobileNav} />
      ) : null}
      <TopHeader>
        <div>
          <TopUl>
            <li>
              <img src={logo1} alt="" />
            </li>
            <li>
              <Link to="/billing">Billing</Link>
            </li>
          </TopUl>
        </div>
        <div>
          {mobileNav === true ? null : (
            <div onClick={() => setMobileNav(true)}>
              <RiMenu3Fill className="menuIcon" />
            </div>
          )}
          <DropUl>
            <li
              className="doc"
              onClick={() => {
                setShowHelp(!showHelp);
                setShowProfile(false);
              }}
              style={{
                backgroundColor: showHelp === true ? "lightgray" : "",
                padding: showHelp === true ? "5px 8px" : "",
                borderRadius: showHelp === true ? "8px" : "",
              }}
            >
              Get Help <IoMdArrowDropdown className="icon" />
            </li>
            <li
              className="border"
              onClick={() => {
                setShowProfile(!showProfile);
                setShowHelp(false);
              }}
            >
              Aman <IoMdArrowDropdown className="icon" />
            </li>
          </DropUl>
        </div>
        {showHelp === true ? (
          <Dropdown>
            <ul>
              <li
                onClick={() => {
                  setShowHelp(false);
                }}
              >
                <Link to="/documentation">
                  View Docs <BiLinkExternal className="iconDocs" />
                </Link>
              </li>
              <li
                onClick={() => {
                  setShowHelp(false);
                }}
              >
                <Link to="/plans">
                  View Plan <BiLinkExternal className="iconDocs" />
                </Link>
              </li>
            </ul>
          </Dropdown>
        ) : null}
        {showProfile === true ? (
          <Profile>
            <ProfileDiv>
              <div className="profile">
                <FaRegUser className="iconPro" />
              </div>
              <h3>Aman Sayyad</h3>
              <p>su9_nmskaar@gmail.com</p>
              <Link to="/manage-account" onClick={() => setShowProfile(false)}>
                <div className="button">Manage your Account</div>
              </Link>
            </ProfileDiv>
            <LinkDiv>
              <ul>
                <li onClick={() => setShowProfile(false)}>
                  <Link to="/documentation">
                    <VscBook className="icon" />
                    Documentation
                  </Link>
                  <Link to="/documentation" className="url">
                    docs.mm.com
                  </Link>
                </li>
                <li onClick={() => setShowProfile(false)}>
                  <Link to="#">
                    <BiSupport className="icon" />
                    Support
                  </Link>
                  <Link to="#" className="url">
                    support.mm.com
                  </Link>
                </li>
                <li onClick={() => setShowProfile(false)}>
                  <Link to="/feedback">
                    <HiOutlineSpeakerphone className="icon" />
                    Give us feedback
                  </Link>
                  <Link to="/feedback" className="url">
                    feedback.mm.com
                  </Link>
                </li>
                <BorderTop></BorderTop>
                <div className="logout">Logout</div>
              </ul>
            </LinkDiv>
          </Profile>
        ) : null}
      </TopHeader>
    </>
  );
};

export default DashHeader;

const TopHeader = styled.div`
  padding: 0px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgb(232, 237, 235);
  box-shadow: rgba(0, 30, 43, 0.1) 0px 4px 4px 0px;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img {
      width: 150px;
      height: 55px;
    }
    .menuIcon {
      display: none;
    }
  }

  @media only screen and (max-width: 991px) {
    div {
      .menuIcon {
        display: block;
        font-size: 28px;
        color: #333;
        cursor: pointer;
      }
    }
  }
`;

const TopUl = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  margin-right: 0px;

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    color: #333;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;

    a {
      color: darkgreen;
    }

    &:nth-child(2) {
      margin-left: 25px;
    }
    .icon {
      margin-left: 5px;
      color: #666;
    }
  }
  .border {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 25px !important;
    border: 2px solid #e7e7e7 !important;
    border-radius: 25px;
  }
`;

const DropUl = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  margin-right: 0px;

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    color: #333;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;

    a {
      color: darkgreen;
    }

    &:nth-child(2) {
      margin-left: 25px;
    }
    .icon {
      margin-left: 5px;
      color: #666;
    }
  }
  .border {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 25px !important;
    border: 2px solid #e7e7e7 !important;
    border-radius: 25px;
  }
  @media only screen and (max-width: 991px) {
    display: none !important;
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: 7%;
  right: 12%;
  background-color: #20204f;
  color: #fff;
  padding: 10px 20px;
  border-radius: 12px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;

  ul {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;

    li {
      list-style: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 5px 0px;
      .doc {
        padding: 5px 8px !important;
      }
      a {
        color: #fff;
        text-align: left;
        margin-right: 2rem;
        font-size: 14px;

        &:hover {
          color: #3aaa35;
        }

        .iconDocs {
          font-size: 15px;
          margin-bottom: -2px;
          margin-left: 0px;
        }
      }
    }
  }
`;

const Profile = styled.div`
  position: absolute;
  top: 8%;
  right: 2%;
  background-color: rgb(28, 45, 56);
  color: #fff;
  width: 260px;
  border-radius: 12px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  z-index: 1000000;
`;

const ProfileDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 25px 0px;

  .profile {
    height: 40px;
    width: 40px;
    background-color: #fff;
    border-radius: 50%;
  }
  h3 {
    font-weight: 400;
    margin-top: 5px;
    font-size: 18px;
  }
  p {
    font-weight: 400;
    margin-top: 0px;
    font-size: 15px;
  }
  .button {
    padding: 5px 10px;
    background-color: #333;
    margin-top: 0.5rem;
    border-radius: 8px;
    cursor: pointer;
    color: #fff;
    text-decoration: none;
  }
  .iconPro {
    color: #005800;
    font-size: 18px;
  }
`;

const LinkDiv = styled.div`
  background-color: rgb(0, 30, 43);
  width: 100%;
  padding: 25px 0px;
  padding-bottom: 10px;
  border-radius: 12px;

  ul {
    margin-left: -30px;
    position: relative;
    li {
      list-style: none;
      margin-bottom: 15px;

      .url {
        color: #016bf8;
        margin-left: 37px;
        margin-top: -4px;
      }
      a {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: #fff;
        font-weight: 400;
        font-size: 14px;

        .icon {
          margin-right: 11px;
          font-size: 25px;
          margin-bottom: -15px;
        }
      }
    }
  }
  .logout {
    text-align: left;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    cursor: pointer;
    margin-bottom: 0px;
    margin-top: 25px;
  }
`;

const BorderTop = styled.div`
  position: absolute;
  left: -21%;
  top: 83.5%;
  background-color: #fff;
  width: 274px;
  height: 1px;
`;
